import { useQuery } from "@tanstack/react-query";
import { AppointmentService } from "../services/AppointmentService";
export function useFollowUpEligibilityQuery(params) {
    const { doctorId, addressId, mode, date, enabled, bookingRevision } = params;
    return useQuery({
        queryKey: [
            "medos",
            "follow-up-eligibility",
            doctorId,
            addressId,
            mode,
            date,
            bookingRevision,
        ],
        queryFn: () => AppointmentService.fetchFollowUpEligibility(doctorId, {
            addressId: addressId,
            mode,
            appointmentDate: date,
        }),
        enabled: enabled && !!doctorId && !!addressId && !!date,
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000,
        retry: 0,
        refetchOnWindowFocus: false,
    });
}
